import React from 'react';
export function ResultsSection() {
  return <section className="py-6 text-gray-800" data-id="element-189">
      <h2 className="text-2xl font-bold mb-6 text-center bg-blue-100 py-3 border-t border-b border-blue-300" data-id="element-190">
        Linda's Incredible Transformation
      </h2>
      <p className="mb-6 leading-relaxed" data-id="element-191">
        Linda's results started immediately, but the real transformation
        happened over the first week:
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-6" data-id="element-192">
        <div className="bg-green-100 p-3 rounded" data-id="element-193">
          <div className="font-bold" data-id="element-194">Day 1</div>
          <div className="text-sm" data-id="element-195">First pain-free moment in months</div>
        </div>
        <div className="bg-green-100 p-3 rounded" data-id="element-196">
          <div className="font-bold" data-id="element-197">Day 3</div>
          <div className="text-sm" data-id="element-198">
            Walked up stairs without gripping the railing
          </div>
        </div>
        <div className="bg-green-100 p-3 rounded" data-id="element-199">
          <div className="font-bold" data-id="element-200">Day 5</div>
          <div className="text-sm" data-id="element-201">Gardened for an hour without discomfort</div>
        </div>
        <div className="bg-green-100 p-3 rounded" data-id="element-202">
          <div className="font-bold" data-id="element-203">Day 7</div>
          <div className="text-sm" data-id="element-204">Played tag with Emma in the backyard</div>
        </div>
      </div>
      <p className="mb-6 leading-relaxed" data-id="element-205">
        "People started noticing the difference before I even mentioned what I
        was doing," Linda recalls.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-206">
        Her husband noticed she wasn't groaning when getting out of bed. Her
        daughters commented that she seemed "more like herself." Emma just knew
        that Grandma was fun again.
      </p>
      <p className="mb-4 leading-relaxed" data-id="element-207">Within two weeks:</p>
      <ul className="list-disc pl-8 mb-6 space-y-2" data-id="element-208">
        <li data-id="element-209">Linda was taking daily walks with her husband</li>
        <li data-id="element-210">She returned to her weekly gardening routine</li>
        <li data-id="element-211">
          Family visits became active adventures instead of sitting sessions
        </li>
        <li data-id="element-212">
          She started planning a hiking trip she'd been putting off for years
        </li>
      </ul>
      <p className="mb-6 leading-relaxed" data-id="element-213">
        But the most dramatic change wasn't physical – it was emotional.
      </p>
      <p className="mb-6 leading-relaxed italic border-l-4 border-gray-300 pl-4" data-id="element-214">
        "I got my confidence back," Linda explains. "I stopped making excuses. I
        stopped avoiding activities. I started saying yes to things again.
      </p>
      <p className="mb-6 leading-relaxed italic border-l-4 border-gray-300 pl-4" data-id="element-215">
        My family got their mom and grandmother back. But more importantly, I
        got myself back."
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-216">
        Now, Linda's morning routine includes 10 minutes with her "weird"
        device. She uses it while drinking coffee and reading the news.
      </p>
      <p className="mb-6 leading-relaxed italic" data-id="element-217">
        "It's become my favorite part of the day," she says. "Ten minutes of
        warmth and relief that gives me the freedom to do whatever I want for
        the rest of the day.
      </p>
      <p className="mb-6 leading-relaxed italic" data-id="element-218">
        Some people start their morning with pills. I start mine with healing."
      </p>
    </section>;
}